var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c(
        "div",
        { staticClass: "account-page payments_form" },
        [
          _c(
            "v-layout",
            { staticClass: "page-layout sl add-funds" },
            [
              _c(
                "v-flex",
                { staticClass: "payment-container" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { id: "form", "lazy-validation": "" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        }
                      },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      !_vm.showSightlineImg
                        ? _c("h1", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Transaction.Sightline.Deposit.Title")
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSightlineImg
                        ? _c("img", {
                            staticClass: "PlayPlusImg",
                            attrs: {
                              src: _vm.mediaServer(
                                "/static/brand-img/" +
                                  _vm.brandKey +
                                  "/sightline.png"
                              ),
                              alt: "Sightline"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("Transaction.Sightline.Deposit.Description")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isProcessingInstructionFetch &&
                      _vm.isInstructionVerified
                        ? _c(
                            "div",
                            [
                              _c("v-text-field", {
                                staticClass: "my-3 input-amount",
                                attrs: {
                                  inputmode: "decimal",
                                  label: _vm.$t("Transaction.Amount"),
                                  prefix: _vm.currencySymbol,
                                  required: "",
                                  disabled: _vm.isProcessing,
                                  rules: [
                                    _vm.formRules.amount.required,
                                    _vm.formRules.amount.lessThanMin,
                                    _vm.formRules.amount.moreThanMax,
                                    _vm.formRules.amount.max2Decimals
                                  ]
                                },
                                model: {
                                  value: _vm.formData.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "amount", $$v)
                                  },
                                  expression: "formData.amount"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: _vm.isProcessing || !_vm.valid,
                                    color: "success"
                                  },
                                  on: { click: _vm.submit }
                                },
                                [_vm._v(_vm._s(_vm.$t("Transaction.AddFunds")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: _vm.isProcessing,
                                    color: "error"
                                  },
                                  on: { click: _vm.reset }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Transaction.ResetForm"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isProcessingInstructionFetch &&
                      !_vm.isInstructionVerified
                        ? _c("div", [
                            _c(
                              "p",
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "blue", size: "16" }
                                  },
                                  [_vm._v("info")]
                                ),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Transaction.Sightline.EnrollmentNotCompletedNote"
                                    )
                                  )
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "go-back" }, [
            _c(
              "span",
              {
                staticClass: "go-back-content",
                on: {
                  click: function($event) {
                    return _vm.goToHomepage()
                  }
                }
              },
              [
                _c("v-icon", [_vm._v("navigate_before")]),
                _c("span", [_vm._v(_vm._s(_vm.$t("Header.navigationBack")))])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "ProcessingDialog",
            {
              attrs: {
                isDialogPersistent: true,
                isProcessing: _vm.isProcessing,
                isSuccess: !_vm.transactionError,
                processingTitle: _vm.$t("Transaction.Dialog.Processing.Title"),
                processingText: _vm.$t("Transaction.Dialog.Processing.Text"),
                successTitle: _vm.$t("Transaction.Dialog.Success.Title"),
                successText: _vm.$t("Transaction.Dialog.Success.Text"),
                errorTitle: _vm.$t("Transaction.Dialog.Error.Title")
              },
              model: {
                value: _vm.getProcessingDialog,
                callback: function($$v) {
                  _vm.getProcessingDialog = $$v
                },
                expression: "getProcessingDialog"
              }
            },
            [
              _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
                _vm.brandKey !== "sb"
                  ? _c(
                      "p",
                      { staticClass: "generic-icon-note" },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "error" } },
                          [_vm._v("error")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("Transaction.Dialog.Error.Text"))
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.transactionError))]),
                _vm._v(" "),
                _vm.brandKey === "sb"
                  ? _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.customerServiceMessage)
                      }
                    })
                  : _vm._e()
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-591c9922", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591c9922","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/IWdepositSightline.vue
// module id = null
// module chunks = 